/* LumaNumbers homepage sections: shared behaviour.
   Each section calls LumaHome.init on its own root, and the theme editor
   re-runs it on shopify:section:load so edits preview live. */
(function () {
  if (window.LumaHome) return;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  function header(root) {
    var hdr = root.querySelector('header.nav'), btn = root.querySelector('[data-burger]');
    if (!hdr || !btn || btn.dataset.bound) return;
    btn.dataset.bound = '1';
    function set(open) { hdr.classList.toggle('menu-open', open); btn.setAttribute('aria-expanded', open); btn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu'); }
    btn.addEventListener('click', function () { set(!hdr.classList.contains('menu-open')); });
    hdr.addEventListener('click', function (e) { if (e.target.closest('nav.menu a')) set(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
    addEventListener('resize', function () { if (innerWidth > 900) set(false); });
  }

  function slider(root) {
    var box = root.querySelector('[data-cat-slider]');
    if (!box || box.dataset.bound) return;
    box.dataset.bound = '1';
    var slides = box.querySelectorAll('.cat-slide'), tabs = box.querySelectorAll('[data-cat-go]'), i = 0, t;
    var delay = (+box.dataset.speed || 6) * 1000;
    box.style.setProperty('--cat-speed', delay / 1000 + 's');
    if (slides.length < 2) return;
    function go(n) {
      n = (n + slides.length) % slides.length; i = n;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === n); });
      tabs.forEach(function (b, k) { b.setAttribute('aria-selected', k === n); b.style.animation = 'none'; void b.offsetWidth; b.style.animation = ''; });
      clearTimeout(t); if (!reduce && box.dataset.autoplay !== 'false') t = setTimeout(function () { go(i + 1); }, delay);
    }
    box._lumaGo = go;
    tabs.forEach(function (b) { b.addEventListener('click', function () { go(+this.dataset.catGo); }); });
    var prev = box.querySelector('[data-cat-prev]'), next = box.querySelector('[data-cat-next]');
    prev && prev.addEventListener('click', function () { go(i - 1); });
    next && next.addEventListener('click', function () { go(i + 1); });
    box.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') go(i - 1); else if (e.key === 'ArrowRight') go(i + 1); });
    box.addEventListener('mouseenter', function () { clearTimeout(t); box.classList.add('is-paused'); });
    box.addEventListener('mouseleave', function () { box.classList.remove('is-paused'); go(i); });
    var x0 = null;
    box.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 44) go(dx < 0 ? i + 1 : i - 1);
    }, { passive: true });
    if (!reduce && box.dataset.autoplay !== 'false') t = setTimeout(function () { go(1); }, delay);
  }

  function reveal(root) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }); }, { threshold: .12 });
    root.querySelectorAll('.rv:not(.in)').forEach(function (el) { io.observe(el); });
    if (reduce) return;
    var heads = [].filter.call(root.querySelectorAll('.sec-head h2, .why-head h2, .luma-about .head h2'), function (h) { return !h.classList.contains('reveal-words'); });
    heads.forEach(function (h) {
      var words = h.textContent.trim().split(/\s+/);
      h.textContent = '';
      h.classList.add('reveal-words');
      words.forEach(function (word, i) {
        var w = document.createElement('span'); w.className = 'w';
        var inner = document.createElement('span');
        inner.textContent = word;
        inner.style.transitionDelay = (i * 85) + 'ms';
        w.appendChild(inner); h.appendChild(w); h.appendChild(document.createTextNode(' '));
      });
    });
    var wio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('words-in'); wio.unobserve(e.target); } }); }, { threshold: .4 });
    heads.forEach(function (h) { wio.observe(h); });
  }

  function compare(root) {
    var ba = root.querySelector('[data-ba]');
    if (!ba || ba.dataset.bound) return;
    ba.dataset.bound = '1';
    var drag = false, auto = true, visible = false, running = false;
    function setPos(x) { var r = ba.getBoundingClientRect(); var p = (x - r.left) / r.width * 100; ba.style.setProperty('--pos', Math.max(0, Math.min(100, p)) + '%'); }
    function loop(ts) { if (!auto || !visible) { running = false; return; } ba.style.setProperty('--pos', (50 + 24 * Math.sin(ts / 1600)).toFixed(2) + '%'); requestAnimationFrame(loop); }
    function start() { if (auto && visible && !running) { running = true; requestAnimationFrame(loop); } }
    ba.addEventListener('pointerdown', function (e) { auto = false; drag = true; try { ba.setPointerCapture(e.pointerId); } catch (_) {} setPos(e.clientX); });
    ba.addEventListener('pointermove', function (e) { if (drag) setPos(e.clientX); });
    addEventListener('pointerup', function () { drag = false; });
    addEventListener('pointercancel', function () { drag = false; });
    if (!reduce) new IntersectionObserver(function (es) { es.forEach(function (e) { visible = e.isIntersecting; if (visible) start(); }); }, { threshold: .15 }).observe(ba);
  }

  function init(root) { root = root || document; header(root); slider(root); compare(root); reveal(root); }

  window.LumaHome = { init: init };
  function boot() { document.querySelectorAll('.luma-page, .luma-about').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  // Theme editor: re-init edited sections and jump the slider to the selected slide.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('.cat-slide'), box = slide && slide.closest('[data-cat-slider]');
    if (box && box._lumaGo) box._lumaGo(+slide.dataset.catSlide);
  });
})();
